function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useContext, useReducer, createContext } from 'react';
import { node } from 'prop-types';
import customThemeColors from '../internals/custom-themes/custom-theme-colors';
var THEMES = customThemeColors;
var CustomThemesStateContext = /*#__PURE__*/createContext();
var CustomThemesDispatchContext = /*#__PURE__*/createContext();
export var ACTIONS = {
  SET_LOGO_ALT: 'set_logo_alt',
  SET_LOGO_URL: 'set_logo_url',
  CLEAR_LOGO: 'clear_logo',
  SELECT_THEME: 'select_theme',
  SET_THEMES_STATE: 'set_themes_state',
  UPDATE_CUSTOM_COLOR: 'update_custom_color',
  CONFIRM_OVERWRITE: 'confirm_overwrite',
  CANCEL_OVERWRITE: 'cancel_overwrite'
};
var getCustomTheme = function getCustomTheme(state) {
  return state.colorThemes[state.colorThemes.length - 1];
};
var getSelectedTheme = function getSelectedTheme(state) {
  var selectedThemeIndex = state.colorThemes.findIndex(function (colorTheme) {
    return colorTheme.title === state.selectedTheme;
  });
  return state.colorThemes[selectedThemeIndex];
};
var getNewCustomTheme = function getNewCustomTheme(state) {
  var customTheme = getCustomTheme(state);
  if (state.selectedTheme === customTheme.title) {
    return customTheme;
  }
  return {
    title: customTheme.title,
    colors: _objectSpread({}, getSelectedTheme(state).colors)
  };
};
var updateCustomThemeColor = function updateCustomThemeColor(state, payload) {
  var value = payload.event.target.value;
  var _getCustomTheme = getCustomTheme(state),
    title = _getCustomTheme.title,
    colors = _getCustomTheme.colors;
  return {
    title: title,
    colors: _objectSpread(_objectSpread({}, colors), {}, _defineProperty({}, payload.colorKey, value))
  };
};
var updateCustomTheme = function updateCustomTheme(state, payload) {
  var overwriteCustom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return [].concat(_toConsumableArray(state.colorThemes.slice(0, state.colorThemes.length - 1)), [overwriteCustom ? getNewCustomTheme(state) : updateCustomThemeColor(state, payload)]);
};
function customThemesReducer(state, _ref) {
  var payload = _ref.payload,
    type = _ref.type;
  var customThemeTitle = state.colorThemes[state.colorThemes.length - 1].title;
  switch (type) {
    case ACTIONS.SET_LOGO_URL:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          logoUrl: payload === null || payload === void 0 ? void 0 : payload.value
        });
      }
    case ACTIONS.CLEAR_LOGO:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          logoUrl: ''
        });
      }
    case ACTIONS.SET_LOGO_ALT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          logoAlt: payload === null || payload === void 0 ? void 0 : payload.value
        });
      }
    case ACTIONS.SELECT_THEME:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedTheme: payload.title
        });
      }
    case ACTIONS.SET_THEMES_STATE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          colorThemes: payload === null || payload === void 0 ? void 0 : payload.colorThemes,
          selectedTheme: payload === null || payload === void 0 ? void 0 : payload.selectedTheme,
          logoUrl: payload === null || payload === void 0 ? void 0 : payload.logoUrl,
          logoAlt: payload === null || payload === void 0 ? void 0 : payload.logoAlt
        });
      }
    case ACTIONS.UPDATE_CUSTOM_COLOR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          colorThemes: updateCustomTheme(state, payload)
        });
      }
    case ACTIONS.CONFIRM_OVERWRITE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          colorThemes: updateCustomTheme(state, payload, true),
          selectedTheme: customThemeTitle
        });
      }
    default:
      {
        throw new Error("Unhandled action type: ".concat(type));
      }
  }
}

/**
 * Provides custom themes, selected theme and logo URL.
 */
var SovosCustomThemeProvider = function SovosCustomThemeProvider(_ref2) {
  var children = _ref2.children;
  var _useReducer = useReducer(customThemesReducer, {
      colorThemes: THEMES,
      selectedTheme: THEMES[0].title,
      logoUrl: '',
      logoAlt: ''
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];

  // prevent rerenders for components that only use dispatch by returning 2 separate providers
  return /*#__PURE__*/React.createElement(CustomThemesDispatchContext.Provider, {
    value: dispatch
  }, /*#__PURE__*/React.createElement(CustomThemesStateContext.Provider, {
    value: state
  }, children));
};
SovosCustomThemeProvider.propTypes = {
  children: node.isRequired
};
export var useCustomTheme = function useCustomTheme() {
  return useContext(CustomThemesStateContext);
};
export var useDispatchCustomTheme = function useDispatchCustomTheme() {
  return useContext(CustomThemesDispatchContext);
};
export default SovosCustomThemeProvider;